'use client'

import BacktestingFeatureHero from '../BacktestingFeatureHero'
import { DashboardFeaturesAdvantageBlocks } from '../../index/DashboardFeaturesAdvantageBlocks'
import RealisticBacktesting from '../../../index/waterfall/RealisticBacktesting'

// --------------------------------------------------------------------------------------------- //

export function BacktestingFeatureView() {
  return (
    <>
      <BacktestingFeatureHero />

      <DashboardFeaturesAdvantageBlocks />
      <RealisticBacktesting />
    </>
  )
}

// --------------------------------------------------------------------------------------------- //
